import { useState } from 'react'

export const useDropZone = () => {
  const [files, setFiles] = useState<File[]>([])
  const [uploadStatus, setIsUploadStatus] = useState<'success' | 'error'>()

  const handleDrop = (files: File[]) => {
    setIsUploadStatus(undefined)
    setFiles(files)
  }

  const handleUploadSuccess = (options?: { resetFiles?: boolean }) => {
    const { resetFiles } = options || {}
    setIsUploadStatus('success')
    if (resetFiles) {
      setFiles([])
    }
  }

  const handleUploadFailure = () => {
    setIsUploadStatus('error')
  }

  const handleRemovePendingFile = (index: number) => () => {
    setFiles(prevFiles => prevFiles.filter((_, i) => i !== index))
  }

  return {
    files,
    setFiles,
    uploadStatus,
    handleDrop,
    handleUploadSuccess,
    handleUploadFailure,
    handleRemovePendingFile,
  }
}
